// ============================================
// switchViewport.js
// 小さい画面幅での viewport 固定制御
//
// 目的:
//   スマートフォンの極小サイズ（古い機種・SE など）で
//   レイアウトが崩れるのを防ぐ。
//   CONFIG.breakpoint 以下の幅になると、viewport を固定幅に切り替える。
//
// 動作例:
//   画面幅 > 375px → width=device-width,initial-scale=1（レスポンシブ）
//   画面幅 ≤ 375px → width=375（固定幅・縮小表示）
// ============================================

// ============================================
// 設定値
// ============================================
const CONFIG = {
  // この幅（px）以下になったとき viewport を固定幅に切り替える
  breakpoint: 375,

  // 固定したときの幅（px）。breakpoint と同じ値にするのが一般的
  fixedWidth: 375,
};

// ============================================
// viewport 切り替え処理
// ============================================
function viewport() {
  const viewportMeta = document.querySelector('meta[name="viewport"]');
  if (!viewportMeta) return;

  // rAF フラグによるスロットリング:
  // resize イベントは非常に頻繁に発火するため、
  // requestAnimationFrame で「次のフレームで1回だけ処理」するよう制限する
  let ticking = false;

  // 初回実行（ページロード時の画面幅を反映する）
  applyViewport();

  window.addEventListener('resize', () => {
    if (ticking) return; // すでに次フレームで処理が予約されていればスキップ
    ticking = true;
    requestAnimationFrame(() => {
      applyViewport();
      ticking = false; // 処理完了後にフラグをリセット
    });
  });

  // viewport の content 属性を画面幅に応じて切り替える
  function applyViewport() {
    const newContent =
      window.outerWidth > CONFIG.breakpoint
        ? 'width=device-width,initial-scale=1' // レスポンシブ
        : `width=${CONFIG.fixedWidth}`; // 固定幅

    // 値が変わっていない場合は DOM 操作をスキップする（不要な再レイアウトを防ぐ）
    if (viewportMeta.getAttribute('content') !== newContent) {
      viewportMeta.setAttribute('content', newContent);
    }
  }
}

export { viewport };
